import {combineReducers} from 'redux';
import privateStateReducer from "./privateStateReducer";
import sharedStateReducer from "./sharedStateReducer";

export const rootReducer = combineReducers({
  private: privateStateReducer,
  shared: sharedStateReducer,
});

export const serverReducer = combineReducers({
  shared: sharedStateReducer,
});

